import React from 'react';
import { Redirect } from 'react-router';
import { Header } from '../../../components/layout/Header';
import { useConfig } from '../../../hooks/useConfig';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { useCurrentUserData } from '../../../hooks/useCurrentUserData';
import { expired } from '../../../utils/expired';
import { LoadingPage } from '../../util-pages/LoadingPage';
import { Inactive } from './Inactive';
import { TrialEnded } from './TrialEnded';
import { VerifyEmail } from './VerifyEmail';

interface GuardedPageProps {
  withHeader?: boolean;
}

export const GuardedPage: React.FC<GuardedPageProps> = ({
  children,
  withHeader,
}) => {
  const currentUser = useCurrentUser();
  const currentUserData = useCurrentUserData();
  const config = useConfig();

  if (!currentUser)
    return <Redirect to={`/login/${window.location.pathname}`} />;

  if (!currentUserData || !config) return <LoadingPage isHeader />;

  const { isAdmin } = currentUserData;
  const isInactive = currentUserData.status === 'inactive';
  const hasTrialEnded = expired(currentUserData);

  const isEmailVerified =
    currentUser.emailVerified || currentUser.email?.includes('@fitnessly.de');

  if (isInactive && !isAdmin && hasTrialEnded)
    return (
      <>
        {withHeader && <Header />}
        <Inactive currentUser={currentUser} config={config} />
      </>
    );

  if (hasTrialEnded && currentUserData.status === 'trial' && !isAdmin)
    return (
      <>
        {withHeader && <Header />}
        <TrialEnded currentUser={currentUser} userData={currentUserData} />
      </>
    );

  if (!isEmailVerified && !isAdmin)
    return (
      <>
        {withHeader && <Header />}
        <VerifyEmail currentUser={currentUser} />
      </>
    );

  return <>{children}</>;
};
